import { createContext, useContext } from 'react';
import { SpeechConfig } from '../../../functions/src/common/types/speechConfig';

export const SpeechConfigContext = createContext<SpeechConfig | null>(null);

export const useSpeechConfig = () => {
  return useContext(SpeechConfigContext);
};
